import { render } from "./RecoveryRequest.vue?vue&type=template&id=70d96835&scoped=true&ts=true"
import script from "./RecoveryRequest.vue?vue&type=script&lang=ts"
export * from "./RecoveryRequest.vue?vue&type=script&lang=ts"

import "./RecoveryRequest.vue?vue&type=style&index=0&id=70d96835&scoped=true&lang=css"

import exportComponent from "D:\\Users\\Anton\\Workspaces\\htdocs\\devloader-userspace\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d96835"]])

export default __exports__